<section class="main_section">
  <!-- <div class="top_navbar">
      <app-home-nav-bar></app-home-nav-bar>
  </div> -->
  <div class="body_section">
    <!-- <div class="our_icon">
        <img src="./../../../../assets/images/logo.svg" alt="">
    </div> -->
    <div class="top_layer">
      <div class="section_title">
        Change Password
      </div>
      <div (click)="cancel()" class="close_icon">
        <mat-icon>close</mat-icon>
      </div>
    </div>
    <div class="hr-line"></div>
    <div class="field business-field-section">
      <div class="label">
        Current Password
      </div>
      <form [formGroup]="currentPwd">
        <mat-form-field appearance="outline" class="sfull-width">
          <input [(ngModel)]="currentPassword" [type]="currentPasswordHide ? 'password' : 'text'" formControlName="password"
                 matInput
                 placeholder="Enter current password"/>
          <mat-icon (click)="currentPasswordHide = !currentPasswordHide" class="eye-icon" matSuffix
                    style="cursor:pointer">{{ currentPasswordHide ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </mat-form-field>
      </form>
    </div>
    <div class="field business-field-section">
      <div class="label">
        New Password
      </div>
      <form [formGroup]="pwd">
        <mat-form-field appearance="outline" class="sfull-width">
          <input [(ngModel)]="password" [type]="passwordHide ? 'password' : 'text'" formControlName="password"
                 matInput
                 placeholder="Enter New password"/>
          <mat-icon (click)="passwordHide = !passwordHide" class="eye-icon" matSuffix
                    style="cursor:pointer">{{ passwordHide ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </mat-form-field>
      </form>
    </div>
    <div class="field business-field-section">
      <div class="label">Confirm Password</div>
      <form [formGroup]="cnfirmPwd">
        <mat-form-field appearance="outline" class="sfull-width">
          <input [(ngModel)]="confirmPassword" [type]="cnfirmPasswordHide ? 'password' : 'text'" formControlName="confirmPassword"
                 matInput
                 placeholder="Confirm password"
          />
          <mat-icon (click)="cnfirmPasswordHide = !cnfirmPasswordHide" class="eye-icon" matSuffix
                    style="cursor:pointer">{{ cnfirmPasswordHide ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </mat-form-field>
      </form>
    </div>
    <div *ngIf="confirmPasswordBoolean" class="password_validation">
      * Passsword and Confirm Password didn't match.
    </div>
    <div class="btn_section">
      <div class="cancel_btn">
        <button (click)="cancel()">Cancel</button>
      </div>
      <div class="submit_btn">
        <button (click)="submit()">
          <span *ngIf="loader"><i class="fas fa-spinner fa-spin"></i>&nbsp;Loading</span>
          <span *ngIf="!loader">Update</span>
        </button>
      </div>
    </div>
  </div>
</section>
